import { AutoCompleteOption } from "@asayinc/component-library";

export const ALL_PROXY_EVENT_TYPE_OPTIONS: AutoCompleteOption[] = [
  {
    name: "Annual Meeting",
    id: "annual_meeting",
  },
  {
    name: "Special Meeting",
    id: "special_meeting",
  },
  {
    name: "Contested Annual Meeting",
    id: "contested_annual_meeting",
  },
  {
    name: "Contested Special Meeting",
    id: "contested_special_meeting",
  },
  {
    name: "Information Statement",
    id: "information_statement",
  },
  {
    name: "Summary Prospectus",
    id: "summary_prospectus",
  },
  {
    name: "19A Notice",
    id: "19_a_notice",
  },
  {
    name: "Annual Report",
    id: "annual_report",
  },
  {
    name: "Semi-Annual Report",
    id: "semi_annual_report",
  },
];

export const VOTING_PROXY_EVENT_TYPE_OPTIONS: AutoCompleteOption[] = [
  {
    name: "Annual Meeting",
    id: "annual_meeting",
  },
  {
    name: "Special Meeting",
    id: "special_meeting",
  },
  {
    name: "Contested Annual Meeting",
    id: "contested_annual_meeting",
  },
  {
    name: "Contested Special Meeting",
    id: "contested_special_meeting",
  },
];

export const INFORMATIONAL_PROXY_EVENT_TYPE_OPTIONS: AutoCompleteOption[] = [
  {
    name: "Information Statement",
    id: "information_statement",
  },
  {
    name: "Summary Prospectus",
    id: "summary_prospectus",
  },
  {
    name: "19A Notice",
    id: "19_a_notice",
  },
  {
    name: "Annual Report",
    id: "annual_report",
  },
  {
    name: "Semi-Annual Report",
    id: "semi_annual_report",
  },
];
